<template>
  <div
      ref="wrapper"
      class="
      code-input
      tw-w-full tw-relative"
  >
    <input
        ref="input"
        type="text"
        name="otp-value"
        id="otp-value"

        v-model="value"
        @input="onInput"

        inputmode="numeric"
        autocomplete="one-time-code"
        required
        :minlength="length"
        :maxlength="length"

        class="tw-block tw-w-full tw-h-[46px] tw-z-10
        tw-rounded-[25px] tw-border-tzz-border tw-border-[1px]
        tw-leading-[46px] tw-text-[15px] tw-text-center
        tw-outline-none tw-bg-white tw-tracking-[5px]"
    />
  </div>
</template>

<script>
export default {
  name: "ui-code-input",
  props: {
    length: {
      type: Number,
      required: true
    }
  },
  data: () => {
    return {
      range: undefined,
      value: undefined,
      fieldsGap: undefined
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (!isNaN(+this.length)) {
        this.range = [...Array(this.length).keys()];
      }
    },
    onInput() {
      if (this.value) {
        this.value = this.value.toUpperCase();
        this.validate();
      }
    },
    set(value) {
      this.value = value;
    },
    // validates only the input format of the code, not the actual code
    validate() {
      //eslint-disable-next-line
      const regexString = `^[\\d]{${this.length}}$`;

      const regex = new RegExp(regexString);

      const isValid = regex.test(this.value);
      this.$emit('validated', isValid);

      if (isValid) {
        this.$emit('valid', this.value);
      }
    },
    clear() {
      this.value = undefined;
    }
  },
  watch: {
    length: function () {
      setTimeout(() => {
        this.init();
      });
    }
  }
}
</script>

<style scoped>

</style>
